import axios from "axios";
import { ElMessage } from "element-plus";
import {store} from "@/store/index.js";
import router from "@/router";
// import { getToken } from "@/utils/auth";
import { variableConfig } from "../../public/pathConfig";
// const pendingMap = new Map();
// function getPendingKey(config) {
//   let { url, method, params, data } = config;
//   if (typeof data === "string") data = JSON.parse(data); // response里面返回的config.data是个字符串对象
//   return [url, method, JSON.stringify(params), JSON.stringify(data)].join("&");
// }
// function addPending(config) {
//   const pendingKey = getPendingKey(config);
//   config.cancelToken =
//     config.cancelToken ||
//     new axios.CancelToken((cancel) => {
//       if (!pendingMap.has(pendingKey)) {
//         pendingMap.set(pendingKey, cancel);
//       }
//     });
// }
// function removePending(config) {
//   const pendingKey = getPendingKey(config);
//   if (pendingMap.has(pendingKey)) {
//     const cancelToken = pendingMap.get(pendingKey);
//     cancelToken(pendingKey);
//     pendingMap.delete(pendingKey);
//   }
// }
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_SAFE_URL,
  // baseURL: "",
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000,
  // headers: {'Accept-Language': 'en-US'},
  method: "POST",
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    console.log()
    // console.log(getPendingKey(config));
    // removePending(config);
    // addPending(config);
    if (store.state.user.token) {
      // 让每个请求携带token
      config.headers["Authorization"] = store.state.user.token;
    }
    return config;
  },
  (error) => {
    if (axios.isCancel(error)) {
      console.log("Request canceled", error.message);
      console.log("🔥request stage 1 error  =>", error); // for debug
    } else {
      // 处理错误
      return Promise.reject(error);
    }
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // removePending(response.config);
    const res = response.data;
    // console.log("👌request response ===>", res);

    if (!res.success) {
      // if (res.code !== 200) {
      switch (res.code) {
        case 401:
        case "B0301":
        case "A0307":
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });

          break;
        // case 403:
        // break
        default:
          ElMessage({
            message:
              res.message && res.message.length < 20 ? res.message : "Error",
            // message: res.errorMsg || 'Error',
            type: "error",
            duration: 3 * 1000,
          });
          break;
      }
      return Promise.reject(new Error(res.message));
    } else {
      return Promise.resolve(res);
    }
  },
  (error) => {
    console.log("🔥 request stage 2 error  =>", error); // for debug
    // error.config && removePending(error.config);
    const res = error.response;
    if (
      // error.code != "ERR_CANCELED" &&
      res.data.code &&
      (res.data.code == "B0301" || res.data.code == "A0307")
    ) {
      ElMessage.error(res.data.message);
      // window.location.href = "http://api.insafety.online:28883/#/login";
      setTimeout(() => {
        if (window.location.href.includes("pre")) {
          window.location.href = variableConfig.preLoginPath;
        } else if (window.location.href.includes("orderope")) {
          window.location.href = variableConfig.proLoginPath;
        } else {
          window.location.href = variableConfig.testLoginPath;
        }
      }, 1500);
      // debugger;
      // router.replace({
      //   path: "/login",
      //   query: {
      //     redirect: router.currentRoute.fullPath,
      //   },
      // });
      return Promise.reject(error);
    }
    console.log(error.message)
    ElMessage({
      message: error.message,
      type: "error",
      duration: 3 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
